/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    isAdministrator?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    avatarUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    newPasswordRequired?: boolean;
}

/**
 * Check if a given object implements the UserData interface.
 */
export function instanceOfUserData(value: object): value is UserData {
    return true;
}

export function UserDataFromJSON(json: any): UserData {
    return UserDataFromJSONTyped(json, false);
}

export function UserDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isAdministrator': json['isAdministrator'] == null ? undefined : json['isAdministrator'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'newPasswordRequired': json['newPasswordRequired'] == null ? undefined : json['newPasswordRequired'],
    };
}

export function UserDataToJSON(json: any): UserData {
    return UserDataToJSONTyped(json, false);
}

export function UserDataToJSONTyped(value?: UserData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isAdministrator': value['isAdministrator'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'avatarUrl': value['avatarUrl'],
        'emailConfirmed': value['emailConfirmed'],
        'newPasswordRequired': value['newPasswordRequired'],
    };
}

